export enum LedgerItemType {
  InvestmentResidualCash = 'INVESTMENT_RESIDUAL_CASH',
  InvestmentResidualCashReversal = 'INVESTMENT_RESIDUAL_CASH_REVERSAL',
  InvestmentFrozenCash = 'INVESTMENT_FROZEN_CASH',
  Exit = 'EXIT',
  ExitAmendment = 'EXIT_AMENDMENT',
  Withdrawal = 'WITHDRAWAL',
  RejectedWithdrawal = 'REJECTED_WITHDRAWAL',
  RejectedWithdrawalFee = 'REJECTED_WITHDRAWAL_FEE',
  NewInvestment = 'NEW_INVESTMENT',
  Interest = 'INTEREST',
  Dividend = 'DIVIDEND',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  InvestorFee = 'INVESTOR_FEE',
  WithdrawalFee = 'WITHDRAWAL_FEE',
  InvestorDiscount = 'INVESTOR_DISCOUNT',
  Transfer = 'TRANSFER',
}
